import React from 'react'
import { Nav, Navbar } from '@softwaredev_cegeka/stix-core'
import { UserMenu } from '../Menu'
import { Link, NavLink } from 'react-router-dom'
import { rootLinks } from '../../assets/data/menu.js'
import logo from '../../assets/images/cegeka-logo-white.png'
import { Observer } from 'mobx-react'
import { authenticatedUserStore } from '../../stores'
// Style
import './header.scss'

const Header = () => {
    return (
        <Navbar fixed={'top'} sticky={'top'} variant={'dark'}>
            <Navbar.Brand>
                <Link to="/">
                    <img src={logo} alt={'News UI logo'} />
                </Link>
            </Navbar.Brand>
            <Nav>
                {rootLinks.map((link, index) => {
                    return (
                        <Observer key={`header-nav-item-${index}`}>
                            {() => {
                                return authenticatedUserStore.isAllowed(
                                    link.action
                                ) ? (
                                    <NavLink
                                        className="stix-nav-link"
                                        activeClassName="active"
                                        to={`/${link.path}`}
                                        isActive={(match, location) => {
                                            if (match) return match.isExact
                                            return false
                                        }}
                                        key={index}
                                    >
                                        {link.name}
                                    </NavLink>
                                ) : null
                            }}
                        </Observer>
                    )
                })}
            </Nav>
            <Navbar.Right>
                <UserMenu />
            </Navbar.Right>
        </Navbar>
    )
}

export default Header
